import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { loadFailureCart, loadRequestCart, loadSuccessCart } from './actions';

export function* loadPagadores({ payload }: ReturnType<typeof loadRequestCart>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getPagadoresByProduto&token=${state.auth.token}`,
      {
        inscricaoEstadual: payload.inscricaoAtiva,
        centroDistribuicao: payload.cddAtivo,
        codProduto: payload.codProduto,
      }
    );

    yield put(loadSuccessCart(response.data.pagadores));
  } catch (error: any) {
    yield put(loadFailureCart());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar estoque cart, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
